<template>
  <div class="main_info">
    <div class="snapshot_card">
      <span class="card_title">
        {{this.translate('snapshot.main_info')}}
      </span>

      <div class="snapshot_card__content">
        <div v-for="(item, key) in main_info" :key="key" class="snapshot_card__content content-item" >
          <div class="left">
            <span class="title">{{ key }}</span>
          </div>
          <div class="right">
            <span class="title">{{ item }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="snapshot_card">
      <span class="card_title">
        {{this.translate('snapshot.version')}}
      </span>

      <div class="snapshot_card__content">
        <div v-for="(item, key) in firmwares" :key="key" class="snapshot_card__content content-item" >
          <div class="left">
            <span class="title">{{ key }}</span>
          </div>
          <div class="right">
            <span class="title">{{ item }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="snapshot_card" v-if="info.description">
      <span class="card_title">
        {{this.translate('snapshot.desc')}}
      </span>

      <div class="snapshot_card__content">
        <p>
          {{ info.description }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "status",
  props: ['info'],

  data () {
    return {

    }
  },

  computed: {
    main_info() {
      let info = {...this.info}

      info.created_at = this.get_date(info.created_at)
      info.updated_at = this.get_date(info.updated_at)
      info.online_at = this.get_date(info.online_at)

      for (let coordKey in info.coordinates) {
        info['coordinates_' + coordKey] = info.coordinates[coordKey]
      }

      delete (info.firmwares)
      delete (info.coordinates)

      return info
    },
    firmwares(){
      return this.info.firmwares
    }
  },

  methods: {
    get_title(item){
      let r = ''
      for (let key of Object.keys(item)) {
        r = key
      }
      return r
    },
    get_value(item){
      let r = ''
      for (let value of Object.values(item)) {
        r = value
      }
      return r
    },
  },

}
</script>

<style lang="scss" scoped>
  .main_info{
    height: 500px;
    overflow-x: auto;
    padding: 2px;
    &::-webkit-scrollbar{
      width: 10px;
    }
    .snapshot_card {
      box-shadow: 0 2px 2px #ccc5b980;
      color: #252422;
      position: relative;
      border: 1px solid #ccc;
      min-height: 85px;
      background-color: #f8f8f8;
      margin-bottom: 10px;
      .card_title{
        display: block;
        text-align: center;
        padding: 5px;
        background-color: #efe9e9;
        border-bottom: 1px solid #ccc;
      }
      &__content {
        font: 300 12px/16px "Roboto", Arial, sans-serif;
        text-align: center;
        .content-item{
          display: flex;
          justify-content: center;
          align-items: flex-start;
          padding: 5px;
          &:nth-child(2n+1) {
            background-color: #e2ecdc;
          }
          .left{
            width: 40%;
          }
          .right{
            width: 60%;
          }
          div{
            display: flex;
            align-items: center;
            justify-content: flex-start;
            font-size: 12px;
            height: 100%;
            span{
              text-overflow: ellipsis;
            }
          }
        }
      }
      &_footer {
        text-align: center;
        padding: 15px 0 5px;
        border-top: 1px solid #ccc;
      }
    }
  }

  @media (max-width: 475px) {
    .snapshot_card {
      &_content {
        .content-item{
          flex-wrap: wrap;
          .left{
            width: 100%;
          }
          .right{
            width: 100%;
          }
        }
      }
    }
  }


</style>
